import { render } from "./fileManager.vue?vue&type=template&id=87efb0ec"
import script from "./fileManager.vue?vue&type=script&lang=js"
export * from "./fileManager.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Git\\ozmetal\\AdminUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__